import React from 'react';
import s from './styles/NotFoundPage.module.scss';

export const NotFoundPage = () => {
  return (
    <div className={s.page}>
      <h1 className={s.title}>404 - Page Not Found</h1>
    </div>
  );
};
